import { pathOr } from "lib/functions";
import React, { useDispatch, useEffect, useGlobal } from "reactn";
export const useGetForms = ({ officeId, lineId, isTicket, areFormsNeeded }) => {
	const fetchForms = useDispatch("fetchForms");
	const [forms] = useGlobal("forms");
	const [isLoading] = useGlobal("isLoading");

	const reservationForms = pathOr([], ["reservationForms"], forms);
	const ticketForms = pathOr({}, ["ticketForms"], forms);
	const fields = pathOr([], ["fields"], forms);
	const loadingForms = !areFormsNeeded ? false : forms.loading;

	useEffect(() => {
		if (isTicket && !areFormsNeeded) {
			return;
		}
		if (officeId && lineId) {
			fetchForms({ officeId, lineId, isTicket });
		}
	}, [officeId, lineId]);

	return {
		forms: isTicket ? ticketForms : reservationForms,
		fields,
		loading: isLoading || loadingForms,
		error: forms.error,
	};
};
